import React, { ChangeEvent } from "react";

import ModalDialog, { IModalDialogBaseProps } from "./ModalDialog";

import { V2 } from "../../Api";

import "../../form.css";

interface IVehicleAddServiceDialogProps extends IModalDialogBaseProps {
    vehicle: any;
    mode?: "full" | "nextservice"
}

interface IVehicleAddServiceDialogState {
    submitStatus: boolean | string;

    dateServiced: string;
    odometer: string;
    cost: string;
    note: string;

    nextDate: string;
    nextOdometer: string;
}

class VehicleAddServiceDialog extends React.Component<IVehicleAddServiceDialogProps, IVehicleAddServiceDialogState> {
    constructor(props: Readonly<IVehicleAddServiceDialogProps>) {
        super(props);

        this.state = {
            submitStatus: false,
            dateServiced: "",
            odometer: props.vehicle?.tracker?.lastOdometer ? Math.round(props.vehicle?.tracker?.lastOdometer).toString() : "",
            cost: "",
            note: "",

            nextDate: "",
            nextOdometer: "",
        };

        this.submit = this.submit.bind(this);
        this.handleInputChanged = this.handleInputChanged.bind(this);
    }

    public componentDidUpdate(prevProps: Readonly<IVehicleAddServiceDialogProps>) {
        if (prevProps.isOpen !== this.props.isOpen && !this.props.isOpen) {
            // Clear fields
            this.setState({
                cost: "",
                dateServiced: "",
                note: "",
                odometer: "",

                nextDate: "",
                nextOdometer: "",
            });
        }

        if (prevProps.vehicle !== this.props.vehicle && !this.state.odometer) {
            this.setState({
                odometer: this.props.vehicle?.tracker?.lastOdometer ? Math.round(this.props.vehicle?.tracker?.lastOdometer).toString() : ""
            });
        }
    }

    public render() {
        const { isOpen, onRequestClose } = this.props;
        return <ModalDialog isOpen={isOpen} onRequestClose={onRequestClose} className="modal-500px" title={this.props.mode === "nextservice" ? "Next vehicle service" : "Add vehicle service record"}>
            <div className="input-form">
                <div className="info-block">
                    {this.props.mode !== "nextservice"
                        ? <>
                            <section>
                                <div className="input-form-group">
                                    <div>Add service record for <b>{this.props.vehicle.name} {this.props.vehicle?.color || ""}</b></div>
                                </div>
                            </section>
                            <section>
                                <div className="input-form-group">
                                    <label htmlFor="frm-date-serviced" className="required">Date of Service</label>
                                    <input type="date" id="frm-date-serviced" name="dateServiced" value={this.state.dateServiced} onChange={this.handleInputChanged} />
                                </div>
                            </section>
                            <section>
                                <div className="input-form-group">
                                    <label htmlFor="frm-odometer" className="required">Mileage</label>
                                    <input type="number" id="frm-odometer" name="odometer" value={this.state.odometer} onChange={this.handleInputChanged} />
                                </div>
                                <div className="input-form-group">
                                    <label htmlFor="frm-cost" className="required">Cost</label>
                                    <input type="number" id="frm-cost" name="cost" step={0.01} min={0.00} value={this.state.cost} onChange={this.handleInputChanged} />
                                </div>
                            </section>
                            <section>
                                <div className="input-form-group">
                                    <label htmlFor="frm-note">Note</label>
                                    <textarea id="frm-note" className="input-textarea-medium noflex" name="note" value={this.state.note} onChange={this.handleInputChanged} />
                                </div>
                            </section>
                        </>
                        : null}
                    <section>
                        <div className="input-form-group">
                            <label htmlFor="frm-next-date">Next Service Date</label>
                            <input type="date" id="frm-next-date" name="nextDate" value={this.state.nextDate} onChange={this.handleInputChanged} />
                        </div>
                        <div className="input-form-group">
                            <label htmlFor="frm-next-odometer">Next Service Mileage</label>
                            <input type="number" id="frm-next-odometer" name="nextOdometer" value={this.state.nextOdometer} onChange={this.handleInputChanged} />
                        </div>
                    </section>
                    &nbsp;
                    {this.state.submitStatus === true
                        ? <div className="spinner lds-dual-ring" />
                        : typeof this.state.submitStatus === "string"
                            ? <div className="error-text">{this.state.submitStatus}</div>
                            : null
                    }
                    <div className="action-panel-dialog">
                        <button type="button" className="button push-right text-with-icon" onClick={this.submit}><i className="icon-check" /><span>Save</span></button>
                    </div>
                </div>
            </div>
        </ModalDialog>;
    }

    private async submit() {
        try {
            this.setState({
                submitStatus: true
            });

            const data = {
                record: undefined as any,
                nextServiceDate: this.state.nextDate || undefined,
                nextServiceMileage: this.state.nextOdometer || undefined,
            };

            if (this.props.mode !== "nextservice") {
                if (!this.state.dateServiced) {
                    throw new Error("Date must not be empty");
                }
                if (!this.state.odometer) {
                    throw new Error("Mileage must not be empty");
                }
                if (!this.state.cost) {
                    throw new Error("Cost must not be empty");
                }

                data.record = {
                    dateServiced: this.state.dateServiced,
                    mileage: this.state.odometer,
                    cost: this.state.cost,
                    note: this.state.note || undefined
                };
            }

            await V2.post(`vehicles/${this.props.vehicle.id}/service`, data);

            this.setState({
                submitStatus: false
            });

            this.props.onRequestClose(true);
        }
        catch (e) {
            this.setState({
                submitStatus: e.message || "Failed to submit"
            });
        }
    }

    private handleInputChanged(e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement> | ChangeEvent<HTMLTextAreaElement>) {
        const name = e.currentTarget.name;
        const value = e.currentTarget.type === "checkbox" ? (e.currentTarget as HTMLInputElement).checked : e.currentTarget.value;

        this.setState({
            [name]: value
        } as any);
    }
}

export default VehicleAddServiceDialog;
